import _typeof from './../../external_lib/@babel/runtime/helpers/esm/typeof.js';
import rules from '../rule/index.js';
var required = function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : _typeof(value);
  rules.required(rule, value, source, errors, options, type);
  callback(errors);
};
export { required as default };
//# sourceMappingURL=required.js.map
